import React from 'react';
import { MdInbox } from 'react-icons/md';

interface EmptyStateProps {
  title?: string;
  description?: string;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'No data found',
  description = 'There is nothing to display here yet.',
  action,
}) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    <MdInbox className="text-gray-300 mb-3" size={48} />
    <h4 className="text-sm font-semibold text-gray-500">{title}</h4>
    <p className="text-xs text-gray-400 mt-1 max-w-xs">{description}</p>
    {action && <div className="mt-4">{action}</div>}
  </div>
);